<template>
    <el-dialog 
        :visible.sync="openStatus"
        :title="$t('slb.text.addDomain')"
        :close-on-click-modal="false"
        custom-class="add-domain-dialog" 
        @close="doClose">
        <el-table :data="domainList"
            :max-height="maxHeight">
            <!--域名-->
            <el-table-column 
                :label="$t('slb.text.domain')"
                key="domain"
                >
                <template slot-scope="scope">
                    <el-input v-if="scope.row.isEditing" 
                        :placeholder="$t('slb.sentence.inputDomain')"
                        v-model="scope.row.domain" 
                        @input="(val) => checkDomain(val,scope)"></el-input>
                    <span v-else>{{scope.row.domain}}</span>
                    <p class="el-form-item-help el-form-item-help-error" v-if="
                    scope.row.isDomainIllegality">
                        {{$t('slb.sentence.domainNotStandardTip')}}
                    </p>
                    <p class="el-form-item-help el-form-item-help-error" v-if="scope.row.isDomainRepetition">
                        {{$t('slb.sentence.domainRepeatTip')}}
                    </p>
                </template>
            </el-table-column>
            <!--证书-->
            <el-table-column 
                :label="$t('slb.text.certificate')"
                key="certificate">
                <template slot-scope="scope">
                    <el-select 
                        v-if="scope.row.isEditing"
                        v-model="scope.row.certificate">
                        <el-option 
                            v-for="item in certificates" :key="item.value" :label="item.label"
                            :value="item">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.certificate.label}}</span>
                </template>
            </el-table-column>  
            <!--操作-->
            <el-table-column prop="operation" key="operation" min-width="90"
                :label="$t('listPage.tableLabel.operation')">
                <template slot-scope="scope">
                    <!--保存-->
                    <a href="javascript:void(0)" @click="saveDomain(scope)"
                        :class="{'operation': scope.row.isEditing}"
                        v-if="scope.row.isEditing">
                        {{$t('subnet.text.save')}}
                    </a>
                    <!--编辑-->
                    <a href="javascript:void(0)" @click="editDomain(scope)"
                        :class="{'operation': scope.row.isEditing}"
                        v-if="!scope.row.isEditing">
                        {{$t('subnet.text.edit')}}
                    </a>
                    <!--删除-->
                    <a href="javascript:void(0)" @click="deleteDomain(scope)"
                        :class="[{'operation': scope.row.isEditing}]">
                        {{$t('subnet.text.delete')}}
                    </a>
                </template>
            </el-table-column>
        </el-table>
        <!--添加扩展域名-->
        <section class="add-domain">
            <el-tooltip :content="$t('slb.sentence.domainTotalTip')" placement="right"
                :disabled="!addIconDisabled">
                <a @click="addOneRow"
                    class="add-domain-button"
                    :class="{'cps-dropdown-disabled': addIconDisabled }">
                    <i class="jc-icon-plus"></i>
                    {{$t('slb.text.addDomain')}}
                </a>
            </el-tooltip>
            <span>(</span>
            <span class="highlight-font-color">{{addedQuantities}}</span>
            <span>/</span>
            <span class="highlight-font-color">20</span>
            <span>)</span>
        </section> 
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('listPage.text.cancelButton') }}</el-button>
            <el-button type="primary" @click="doConfirm" :disabled="isRowNotSaved || !domainList.length">
                {{ $t('listPage.text.sureButton') }}
            </el-button>
        </span>
    </el-dialog>
</template>


<script>
import {compose} from '@/common/tool';
import * as Reg from "@/common/reg";
// 手动添加20条+1条默认值
const domainQuota = 21; 
export default {
    data() {
        return {
            openStatus: this.dialogVisible,
            certificates: [],
            domainList: [],
            maxHeight: 600,
            // 上一条数据是否未保存
            isRowNotSaved: false,
        };
    },
    computed: {
        // 添加扩展域名按钮禁用
        addIconDisabled() {
            if(this.domainRestNumber === 0) {
                return true
            } else {
                return false
            }
        },
        // 还可添加多少个域名
        domainRestNumber() {
            let domainNumber = this.domainList.length;
            let iCount = domainQuota - domainNumber-this.currentDomainsQuantities;
            return iCount > 0 ? iCount : 0
        },
        // 已添加多少个域名
        addedQuantities() {
            return this.domainList.length + this.currentDomainsQuantities-1
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        region: {
            type: String,
        },
        listenerId: {
            type: String
        },
        currentDomainsQuantities: {
            type: Number,
        }
    },
    watch: {
        dialogVisible(val) {
            this.openStatus = val;
        },
    },
    mounted() {
        this.getSlbCertListData();
    },
    methods: {
        // 关闭弹框
        doClose() {
            this.$emit('update:dialogVisible', false);
        },
        // 点击确认按钮，提交扩展域名
        doConfirm() {
            let submitDomain = compose(this.submitDomain,this.dealSubmitDomainParams);
            submitDomain();
        },

        /**
            **@disc: 获取负载均衡证书数据
            **@params: none
        */
        getSlbCertListData() {
            this.refreshLoading = true;
            const param = {
                region: this.region,
            };
            Ajax.get('/api/cps/queryCertificatePage', param)
            .then((res) => {
                this.certificates = res.data.certs.map(item => {
                    return {
                        label: item.name,
                        value: item.certId
                    }
                });
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.refreshLoading = false;
            })
        },

        dealSubmitDomainParams() {
            return this.domainList.map(item => {
                return {
                    certificateId: item.certificate.value,
                    domain: item.domain,
                    listenerId: this.listenerId,
                    region: this.region
                }
            });
        },
        submitDomain(params) {

            Ajax.put('/api/cps/listenerSni', params, {
                headers: {
                  'Content-Type': 'application/json'
                }
            })
            .then((res) => {
                if (res.data && res.data.success) {
                    this.$message.success(this.$t('subnet.text.operationSuccess'));
                    this.$emit('addComplete');
                }
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            }).finally( () => {
                this.doClose();
            });
        },
        // 编辑当前行
        editDomain(scope) {
            scope.row.isEditing = true;
            this.setIsRowNotSaved(true);
        },

        // 保存当前行
        saveDomain(scope) {
            this.checkDomain(scope.row.domain,scope);
            if (scope.row.isDomainIllegality || scope.row.isDomainRepetition || !scope.row.certificate.value) {
                return
            }
            this.setIsRowNotSaved(false);
            scope.row.isEditing = false;
        },

        // 删除当前行
        deleteDomain(scope) {
            this.domainList.splice(scope.$index, 1);
            this.setIsRowNotSaved(false);
            scope.row.isEditing = false;
        },

        // 添加一行
        addOneRow() {
            if (this.isRowNotSaved || this.domainRestNumber === 0) {
                return false
            }
            const row = {
                'domain': '',
                'certificate': {
                    label: '',
                    value: ''
                },
                'isEditing': true,
                // 域名是否非法
                'isDomainIllegality': false,
                // 域名是否重复
                'isDomainRepetition': false,

            };
            this.domainList.push(row);
            this.setIsRowNotSaved(true);
        },

        checkDomain(domain,scope) {
            let isValidDomain = Reg.domain.test(domain) || Reg.wildcardDomain.test(domain);
            if (isValidDomain) {
                scope.row.isDomainIllegality = false;
            } else {
                scope.row.isDomainIllegality = true;
            }

            let domains = this.domainList.filter(item => item.domain === domain);
            if (domains.length > 1) {
                scope.row.isDomainRepetition = true;
            } else {
                scope.row.isDomainRepetition = false;
            }
        },

        setIsRowNotSaved(data) {
            this.isRowNotSaved = data;
        }
    }
};
</script>

<style lang="scss">
    @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/slb/addDomain/AddDomain.vue